import { FC } from 'react';
import { Link } from 'react-router-dom';
import styles from '@/components/controls/Button/Button.module.scss';
import { ButtonPropsIF } from '@/components/controls/Button/Button.types';

const Button: FC<ButtonPropsIF> = ({
    children,
    href,
    disabled,
    className = '',
    type = 'button',
    variant = 'accent',
    htmlFor,
    icon,
    isLoading,
    isCustom,
    dataTest,
    ref,
    clickHandler,
    ...restProps
}) => {
    const commonProps = {
        disabled: disabled || isLoading,
        className: isCustom
            ? `${className}`
            : `flc ${styles.button} ${icon ? styles.hasIcon : ''} ${styles[variant]} ${className} ${isLoading ? styles.loading : ''} ${disabled ? styles.disabled : ''}`,
        'data-test': dataTest,
    };

    if (href) {
        return (
            <Link {...commonProps} to={href}>
                {icon && <span className={`flc ${styles.icon}`}>{icon}</span>}
                {children}
            </Link>
        );
    }

    if (htmlFor) {
        return (
            <label {...commonProps} htmlFor={htmlFor}>
                {icon && <span className={`flc ${styles.icon}`}>{icon}</span>}
                {children}
            </label>
        );
    }

    return (
        <>
            <button
                {...restProps}
                {...commonProps}
                type={type}
                onClick={(event) => {
                    restProps.onClick?.(event);
                    clickHandler?.();
                }}
                ref={ref}
            >
                {isLoading && !['sq', 'link'].includes(variant) && (
                    <span className={styles.spinnerWrapper}>
                        <span className="spinner"></span>
                    </span>
                )}
                {icon && !isLoading && variant !== 'link' && (
                    <span className={`flc ${styles.icon}`}>{icon}</span>
                )}
                {children}
            </button>
        </>
    );
};

export default Button;
